import { jsx as d } from "react/jsx-runtime";
import { forwardRef as g } from "react";
import m from "@mui/material/Chip";
import v from "styled-components";
import C from "../../icons/clear.js";
import { getFlavorColor as l, hexToRgba as p, getBackground as n, getColorHover as r, getColorPress as t, getBorderColorPress as y, variants as c } from "../../theme/utils/styleUtils.js";
const D = {
  root: "chipRoot",
  clickable: "chipClickable",
  disabled: "chipDisabled",
  label: "chipLabel",
  outlined: "outlined",
  icon: "iconDefault",
  deleteIcon: "deleteIcon",
  focusVisible: "chipFocusVisible"
}, R = (o) => {
  let i = "24px";
  return o === "small" && (i = "20px"), o === "large" && (i = "30px"), i;
}, k = v(m).withConfig({
  displayName: "StyledChip"
})([
  "&&.chipRoot{height:",
  ";color:",
  ";background-color:",
  ";align-items:center;border:solid 1px transparent;border-radius:4px;padding:5px 8px;.iconDefault{width:12px;height:12px;margin:0px 8px 0px 0px;padding:0px;color:",
  ";}}&& .chipLabel{font-size:",
  ";line-height:14px;padding:0px;}&&.chipRoot.chipClickable:hover{color:",
  ";background-color:",
  ";border-color:",
  ";}&&.chipRoot.chipClickable:hover .iconDefault{color:",
  ";}&&.chipRoot .deleteIcon{height:12px;width:12px;margin:0px 0px 0px 8px;padding:0px;color:",
  ";&:hover{color:",
  ";}&:focus{box-shadow:0px 0px 4px 0px ",
  ";}&:active{color:",
  ";}}&&.outlined{border:solid 1px ",
  ";}&&.chipRoot.Mui-focusVisible{box-shadow:0px 0px 4px 0px ",
  ";}&&.chipRoot.chipClickable:active{color:",
  ";border:solid 1px ",
  ";box-shadow:none;}&&.chipRoot.chipClickable:active .iconDefault{color:",
  ";}&&.chipRoot.chipDisabled{color:",
  ";background-color:",
  ";opacity:1;}&&.chipRoot.chipDisabled .iconDefault{color:",
  ";}&&.chipRoot.chipDisabled .deleteIcon{color:",
  ";}"
], ({ $size: o }) => R(o), ({ $flavor: o, theme: i }) => l(i, o), ({ $flavor: o, theme: i, variant: e }) => p(n(i, e === "filled" ? c.contained : c.outlined, o), 0.1), ({ $flavor: o, theme: i }) => l(i, o), ({ theme: o }) => o.typography.body100.fontSize, ({ $flavor: o, theme: i }) => r(i, void 0, o), ({ $flavor: o, theme: i, variant: e }) => p(n(i, e === "filled" ? c.contained : c.outlined, o), 0.1), ({ $flavor: o, theme: i, variant: e }) => e === "filled" ? "transparent" : r(i, void 0, o), ({ $flavor: o, theme: i }) => r(i, void 0, o), ({ $flavor: o, theme: i }) => l(i, o), ({ $flavor: o, theme: i }) => r(i, void 0, o), ({ theme: o }) => o.primaryFocus, ({ theme: o, $flavor: i }) => t(o, void 0, i), ({ $flavor: o, theme: i }) => l(i, o), ({ theme: o }) => o.primaryFocus, ({ $flavor: o, theme: i, variant: e }) => t(i, e, o), ({ $flavor: o, theme: i, variant: e }) => y(i, e, o), ({ $flavor: o, theme: i, variant: e }) => t(i, e, o), ({ theme: o }) => o.secondaryDisabled, ({ theme: o }) => p(o.primaryDisabled, 0.5), ({ theme: o }) => o.secondaryDisabled, ({ theme: o }) => o.secondaryDisabled), w = /* @__PURE__ */ g(({ classes: o, component: i = "button", deleteIcon: e = /* @__PURE__ */ d(C, {}), onClick: a = void 0, onDelete: s = void 0, size: h = "medium", flavor: x = "normal", variant: b = "filled", ...u }, f) => /* @__PURE__ */ d(k, {
  clickable: !!a,
  component: i,
  ...u,
  ref: f,
  classes: {
    ...D,
    ...o
  },
  deleteIcon: e,
  color: "default",
  onClick: a,
  onDelete: s,
  variant: b,
  $flavor: x,
  $size: h
}));
w.displayName = "Chip";
export {
  w as default
};
